/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./doorCard.vue?vue&type=template&id=eb7f531c&scoped=true&"
import script from "./doorCard.vue?vue&type=script&lang=js&"
export * from "./doorCard.vue?vue&type=script&lang=js&"
import style0 from "./doorCard.vue?vue&type=style&index=0&id=eb7f531c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb7f531c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VCard,VChip,VIcon})
